import React from 'react';
import { Link } from 'react-router-dom';

export default function SellWithUs() {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px', fontFamily: 'sans-serif' }}>
      
      {/* Hero Section */}
      <div style={{ textAlign: 'center', padding: '60px 20px', backgroundColor: '#1a1a1a', color: 'white', borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)', marginBottom: '40px' }}>
        <h1 style={{ fontSize: '48px', margin: '0 0 20px 0', fontWeight: '900' }}>Stop losing your margins.</h1>
        <p style={{ fontSize: '20px', color: '#adb5bd', maxWidth: '600px', margin: '0 auto 30px auto', lineHeight: '1.6' }}>
          eBay takes 13%+. We take a flat 7%. Join the ultimate neighborhood marketplace built specifically for tech, hardware, and physical media.
        </p>
        <Link to="/login" style={{ padding: '16px 32px', backgroundColor: '#007bff', color: 'white', textDecoration: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: 'bold', display: 'inline-block', boxShadow: '0 4px 15px rgba(0,123,255,0.3)' }}>
          Start Selling Today
        </Link>
      </div>

      {/* Feature Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginBottom: '40px' }}>
        
        <div style={featureCard}>
          <div style={iconCircle}>🚀</div>
          <h3 style={featureTitle}>Power Seller Tools</h3>
          <p style={featureText}>Moving a pallet of networking equipment? Use our CSV Bulk Importer to push 100 active listings to the database in seconds.</p>
        </div>

        <div style={featureCard}>
          <div style={iconCircle}>🛡️</div>
          <h3 style={featureTitle}>Safe Local Exchange</h3>
          <p style={featureText}>Skip the shipping fees. Our platform automatically recommends verified safe, well-lit public zones for local hardware swaps.</p>
        </div>

        <div style={featureCard}>
          <div style={iconCircle}>🎯</div>
          <h3 style={featureTitle}>The ISO Board</h3>
          <p style={featureText}>Don't wait for buyers. Check the neighborhood Bounty Board to see exactly what hardware people are actively looking to buy right now.</p>
        </div>

      </div>

      {/* Trust & Math Section */}
      <div style={{ backgroundColor: '#f8f9fa', padding: '40px', borderRadius: '16px', border: '1px solid #e9ecef', textAlign: 'center' }}>
        <h2 style={{ margin: '0 0 20px 0', fontSize: '28px' }}>The Math is Simple.</h2>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <div style={mathCard}>
            <p style={{ margin: '0 0 10px 0', color: '#6c757d', fontWeight: 'bold' }}>If you sell a $500 GPU on eBay:</p>
            <p style={{ fontSize: '24px', fontWeight: '900', color: '#dc3545', margin: 0 }}>You keep ~$425</p>
          </div>
          <div style={{ ...mathCard, borderColor: '#28a745', backgroundColor: '#f0fff4' }}>
            <p style={{ margin: '0 0 10px 0', color: '#155724', fontWeight: 'bold' }}>If you sell a $500 GPU on Nundinaria (7%):</p>
            <p style={{ fontSize: '24px', fontWeight: '900', color: '#28a745', margin: 0 }}>You keep $465</p>
          </div>
        </div>
      </div>
      
    </div>
  );
}

const featureCard = { backgroundColor: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', border: '1px solid #eee' };
const iconCircle = { width: '50px', height: '50px', backgroundColor: '#e6f2ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', marginBottom: '20px' };
const featureTitle = { margin: '0 0 10px 0', fontSize: '20px' };
const featureText = { margin: 0, color: '#6c757d', lineHeight: '1.5' };
const mathCard = { padding: '20px', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #dee2e6', minWidth: '250px' };